export default __webpack_public_path__ + "static/media/requiere_interno.debb7243.svg";